import { render, staticRenderFns } from "./SettingBanner.page.vue?vue&type=template&id=8380b6e0&"
import script from "./SettingBanner.page.vue?vue&type=script&lang=js&"
export * from "./SettingBanner.page.vue?vue&type=script&lang=js&"
import style0 from "./SettingBanner.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports